import { render } from "./ChessBoard.vue?vue&type=template&id=1698f69d&scoped=true"
import script from "./ChessBoard.vue?vue&type=script&lang=js"
export * from "./ChessBoard.vue?vue&type=script&lang=js"

import "./ChessBoard.vue?vue&type=style&index=0&id=1698f69d&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1698f69d"]])

export default __exports__